import { defineStore } from "pinia";
import {
  collection,
  query,
  getFirestore,
  getDocs,
  where
} from "firebase/firestore";
import { userUserStore } from "../stores/user";

import { actualizarUsuarioDeEmpresa } from "./cloudFunctions/actualizarUsuarioDeEmpresa";
import { establecerContrasena } from "./cloudFunctions/establecerContrasena";
import { establecerPinUsuario } from "./cloudFunctions/establecerPinUsuario";
import { Usuario, usuarioConverter } from "@fixeduy/restaurantestypes";

export const useUsuariosStore = defineStore({
  id: "usuarios",
  persist: true,
  state: () => {
    return {
      _usuarios: [] as Usuario[],
      cargando: false
    };
  },
  getters: {
    usuarios(): Usuario[] {
      return this._usuarios.filter(user => {
        return !user.mail.endsWith("@fixed.uy");
      });
    },

    getUltimaUsuariosEdicion(): number {
      let mayorFechaUltimaEdicion = 0;
      this._usuarios
        .filter(user => {
          return !user.mail.endsWith("@fixed.uy");
        })
        .map(r => {
          if (r.ultimaEdicion > mayorFechaUltimaEdicion) {
            mayorFechaUltimaEdicion = r.ultimaEdicion;
          }
        });
      return mayorFechaUltimaEdicion;
    }
  },
  actions: {
    async actualizar(
      usuario: Usuario,
      nombre: string,
      activo: boolean,
      rolId: string
    ) {
      return actualizarUsuarioDeEmpresa({
        usuarioId: usuario.id,
        nombre: nombre,
        activo: activo,
        rolId: rolId
      });
    },
    async establecerContrasena(usuario: Usuario, contrasena: string) {
      return establecerContrasena({
        usuario: usuario,
        contrasena: contrasena
      });
    },
    async establecerPin(usuario: Usuario, pin: string) {
      const userStore = userUserStore();
      const empresaId = userStore.empresa?.id;
      const db = getFirestore();
      const collectionRoute = `empresas/${empresaId}/usuarios`;

      if (!empresaId) throw new Error("No hay empresa seleccionada");

      const q = query(
        collection(db, collectionRoute).withConverter(usuarioConverter),
        where("pin", "==", pin)
      );

      const querySnapshot = await getDocs(q);

      const existePin = querySnapshot.docs.length > 0;

      if (existePin) {
        throw new Error("Error al establecer pin");
      }

      return establecerPinUsuario({
        usuarioId: usuario.id,
        pin,
        idEmpresa: empresaId
      });
    },
    async getFromFirestore() {
      const db = getFirestore();
      const userStore = userUserStore();
      const empresaId = userStore.empresa?.id;
      if (!empresaId) {
        this._usuarios = [];
        return Promise.resolve();
      }
      const collectionRoute = `empresas/${empresaId}/usuarios/`;

      // Solo mostrar usuarios de la empresa actual: reemplazar lista en cada carga
      this._usuarios = [];
      const mayorFechaUltimaEdicion = 0;

      return new Promise<void>(resolve => {
        getDocs(
          query(
            collection(db, collectionRoute),
            where("ultimaEdicion", ">=", mayorFechaUltimaEdicion)
          ).withConverter(usuarioConverter)
        ).then(querySnapshot => {
          querySnapshot.forEach(doc => {
            this.addUsuarioStore(doc.data());
          });
          resolve();
        });
      });
    },
    addUsuarioStore(usuario: Usuario) {
      // reviso que no exista
      for (let i = 0; i < this._usuarios.length; i++) {
        if (this._usuarios[i].id == usuario.id) {
          this._usuarios[i] = usuario;
          return; // corto ejecucion de la funcion
        }
      }

      // lo inserto y ordeno
      this._usuarios.push(usuario);
      this._usuarios.sort((a, b) => (b.nombre > a.nombre ? -1 : 1));
    },
    getById(id: string): Usuario | null {
      for (let i = 0; i < this._usuarios.length; i++) {
        if (this._usuarios[i].id == id) {
          return this._usuarios[i];
        }
      }

      return null;
    }
  }
});
